import { useCallback, useState } from "react";
import { Path } from "../types/route";

export function useRoute() {
  const [path, _setPath] = useState<Path>("select_color");
  const setPath = useCallback((path: Path) => {
    _setPath(path);
    window.scrollTo({ top: 0 });
  }, []);

  return {
    path,
    setPath,
  };
}
